<template>
  <div class="about">
    <h1>College Counseling</h1>
  </div>
</template>
